import { render, staticRenderFns } from "./WelcomeProjectCard.vue?vue&type=template&id=19556f40"
import script from "./welcome-project-card.ts?vue&type=script&lang=ts&external"
export * from "./welcome-project-card.ts?vue&type=script&lang=ts&external"
import style0 from "./welcome-project-card.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports